import React from "react";
import { Link } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaPhone,
  FaClock,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";
import LOGO from "../../assets/logos/flipcity-logo.png";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-4">
              <img
                src={LOGO}
                alt="Flipcity Gymnastics Academy"
                className="h-12 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Building champions one flip at a time. Gymnastics training for
              kids aged 4–16 in Sector 93, Gurgaon. Serving families from DLF
              Garden City, Signature Global City 93, Spaze Privvy &amp; nearby
              sectors.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-slate-400 hover:text-white transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/classes"
                  className="text-sm text-slate-400 hover:text-white transition-colors"
                >
                  Classes
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-sm text-slate-400 hover:text-white transition-colors"
                >
                  Pricing
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-slate-400 hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5 text-sm">
                <FaMapMarkerAlt className="text-primary-400 mt-0.5 flex-shrink-0" />
                <span className="text-slate-400">
                  IMT Rd, near Jotram Chowk,
                  <br />
                  Sector 93, Gurugram
                </span>
              </li>
              <li className="flex items-center gap-2.5 text-sm">
                <FaPhone className="text-primary-400 flex-shrink-0" />
                <a
                  href="tel:+919582691655"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  +91 95826 91655
                </a>
              </li>
              <li className="flex items-center gap-2.5 text-sm">
                <FaClock className="text-primary-400 flex-shrink-0" />
                <span className="text-slate-400">Mon – Sat: 6AM – 9PM</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-semibold mb-4">Follow Us</h4>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/flipcitygymnastic/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 hover:bg-primary-600 p-2.5 rounded-lg transition-colors"
                aria-label="Instagram"
              >
                <FaInstagram className="text-lg" />
              </a>
              <a
                href="https://wa.me/919582691655"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 hover:bg-green-600 p-2.5 rounded-lg transition-colors"
                aria-label="WhatsApp"
              >
                <FaWhatsapp className="text-lg" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <p className="text-center text-xs text-slate-500">
            &copy; {new Date().getFullYear()} Flipcity Gymnastics Academy. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
